module.exports = __webpack_public_path__ + "img/rh.18450c0b.webp";